import { ReactNode } from 'react';
import { QuoteModalProvider } from '@/contexts/QuoteModalContext';
import { QuoteModal } from '@/components/quote/QuoteModal';
import { useAnalyticsTracking } from '@/hooks/useEventTracking';

interface BBQLayoutProps {
  children: ReactNode;
}

// Component to initialize tracking hooks
const AnalyticsTracker = () => {
  useAnalyticsTracking();
  return null;
};

export const BBQLayout = ({ children }: BBQLayoutProps) => {
  return (
    <QuoteModalProvider siteKey="bbq">
      <AnalyticsTracker />
      {children}
      <QuoteModal siteKey="bbq" />
    </QuoteModalProvider>
  );
};

export default BBQLayout;
